export const VERIFICATION_AUTH_TOKEN_KEY = 'argus_token'
export const AGENT_AUTH_TOKEN_KEY = 'agent_token'
export const CLIENT_AUTH_TOKEN_KEY = 'argus_client_token'

export const GLOBAL_SET_LAST_ACTIVITY = 'GLOBAL_SET_LAST_ACTIVITY'
export const GLOBAL_SET_LOADING = 'GLOBAL_SET_LOADING'
export const GLOBAL_SET_FINISHED = 'GLOBAL_SET_FINISHED'

export const VERIFICATION_REQUEST_GET = 'VERIFICATION_REQUEST_GET'
export const VERIFICATION_REQUEST_GET_LIST = 'VERIFICATION_REQUEST_GET_LIST'
export const VERIFICATION_REQUEST_SET_TOKEN = 'VERIFICATION_REQUEST_SET_TOKEN'
export const VERIFICATION_REQUEST_UPLOAD_DOCUMENT = 'VERIFICATION_REQUEST_UPLOAD_DOCUMENT'
export const VERIFICATION_REQUEST_REMOVE_DOCUMENT = 'VERIFICATION_REQUEST_REMOVE_DOCUMENT'
export const VERIFICATION_REQUEST_COMPLETE_DOCUMENT_UPLOAD =
  'VERIFICATION_REQUEST_COMPLETE_DOCUMENT_UPLOAD'
export const VERIFICATION_REQUEST_COMPLETE_QUESTIONNAIRE =
  'VERIFICATION_REQUEST_COMPLETE_QUESTIONNAIRE'
export const VERIFICATION_REQUEST_SKIP_PAYROLL_LINK = 'VERIFICATION_REQUEST_SKIP_PAYROLL_LINK'
export const VERIFICATION_REQUEST_COMPLETE_PAYROLL_LINK =
  'VERIFICATION_REQUEST_COMPLETE_PAYROLL_LINK'
export const VERIFICATION_REQUEST_GENERATE_TRUV_BRIDGE_TOKEN =
  'VERIFICATION_REQUEST_GENERATE_TRUV_BRIDGE_TOKEN'
export const VERIFICATION_REQUEST_START_SESSION_RECORDING =
  'VERIFICATION_REQUEST_START_SESSION_RECORDING'
export const VERIFICATION_REQUEST_STOP_SESSION_RECORDING =
  'VERIFICATION_REQUEST_END_SESSION_RECORDING'
export const VERIFICATION_REQUEST_SKIP_UPLOAD_DOCUMENTS =
  'VERIFICATION_REQUEST_SKIP_UPLOAD_DOCUMENTS'
export const VERIFICATION_REQUEST_REQUEST = 'VERIFICATION_REQUEST_REQUEST'
export const VERIFICATION_REQUEST_SUCCESS = 'VERIFICATION_REQUEST_SUCCESS'
export const VERIFICATION_REQUEST_ERROR = 'VERIFICATION_REQUEST_ERROR'
export const VERIFICATION_REQUEST_SUBMIT_REFERRAL_INTEREST =
  'VERIFICATION_REQUEST_SUBMIT_REFERRAL_INTEREST'

export const AUTH_LOGIN = 'AUTH_LOGIN'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
export const AUTH_REQUEST = 'AUTH_REQUEST'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_ERROR = 'AUTH_ERROR'

export const TASK_GET_NEXT = 'TASK_GET_NEXT'
export const TASK_GET = 'TASK_GET'
export const TASK_ADD_CONTACT_INFO = 'TASK_ADD_CONTACT_INFO'
export const TASK_SCHEDULE_CALLBACK = 'TASK_SCHEDULE_CALLBACK'
export const TASK_COMPLETE_VERIFICATION = 'TASK_COMPLETE_VERIFICATION'
export const TASK_CLOSE_VERIFICATION_THIRD_PARTY_VERIFIER =
  'TASK_CLOSE_VERIFICATION_THIRD_PARTY_VERIFIER'
export const TASK_COMPLETE_TASK = 'TASK_COMPLETE_TASK'
export const TASK_ESCALATE = 'TASK_ESCALATE'
export const TASK_LOG_CALL = 'TASK_LOG_CALL'
export const TASK_SKIP = 'TASK_SKIP'
export const TASK_SEND_AUTHORIZATION = 'TASK_SEND_AUTHORIZATION'
export const TASK_START_IFRAME_SESSION_RECORDING = 'TASK_START_IFRAME_SESSION_RECORDING'
export const TASK_STOP_IFRAME_SESSION_RECORDING = 'TASK_STOP_IFRAME_SESSION_RECORDING'
export const TASK_EXTRACT_RECORDS = 'TASK_EXTRACT_RECORDS'
export const TASK_REQUEST = 'TASK_REQUEST'
export const TASK_SUCCESS = 'TASK_SUCCESS'
export const TASK_ERROR = 'TASK_ERROR'

export const CLIENT_SET_TOKEN = 'CLIENT_SET_TOKEN'
export const ORDER_GET = 'ORDER_GET'
export const ORDER_AUTHORIZE_THIRD_PARTY_VERIFIER_REPORT =
  'ORDER_AUTHORIZE_THIRD_PARTY_VERIFIER_REPORT'

export const ORDER_VIEW_THIRD_PARTY_VERIFIER_REPORT = 'ORDER_VIEW_THIRD_PARTY_VERIFIER_REPORT'
export const ORDER_REQUEST = 'ORDER_REQUEST'
export const ORDER_SUCCESS = 'ORDER_SUCCESS'
export const ORDER_ERROR = 'ORDER_ERROR'

export const ORDER_TEMPLATE_GET_LIST = 'ORDER_TEMPLATE_GET_LIST'
export const ORDER_TEMPLATE_GET = 'ORDER_TEMPLATE_GET'
export const ORDER_TEMPLATE_CREATE = 'ORDER_TEMPLATE_CREATE'
export const ORDER_TEMPLATE_UPDATE = 'ORDER_TEMPLATE_UPDATE'
export const ORDER_TEMPLATE_DEACTIVATE = 'ORDER_TEMPLATE_DEACTIVATE'
export const ORDER_TEMPLATE_REQUEST = 'ORDER_TEMPLATE_REQUEST'
export const ORDER_TEMPLATE_SUCCESS = 'ORDER_TEMPLATE_SUCCESS'
export const ORDER_TEMPLATE_ERROR = 'ORDER_TEMPLATE_ERROR'

export const VENDOR_GET_LIST = 'VENDOR_GET_LIST'
export const VENDOR_REQUEST = 'VENDOR_REQUEST'
export const VENDOR_SUCCESS = 'VENDOR_SUCCESS'
export const VENDOR_ERROR = 'VENDOR_ERROR'

export const CLIENT_USER_GET_LIST = 'CLIENT_USER_GET_LIST'
export const CLIENT_USER_REQUEST = 'CLIENT_USER_REQUEST'
export const CLIENT_USER_SUCCESS = 'CLIENT_USER_SUCCESS'
export const CLIENT_USER_ERROR = 'CLIENT_USER_ERROR'
